import ChartYAxisGrid from './ChartYAxisGrid';
import ChartBenchmarkGrid from './ChartBenchmarkGrid';

interface ChartYAxisProps {
  bottomOffset: string;
  isBenchmarkEnabled: any;
  benchmarkDetails: any;
  isChartScrollable: boolean;
}
function ChartYAxis({
  bottomOffset,
  isBenchmarkEnabled,
  benchmarkDetails,
  isChartScrollable,
}: ChartYAxisProps) {
  return (
    <div
      className={`absolute top-0 right-0 left-0 flex h-full gap-x-4 ${isChartScrollable && 'right-2'}`}
    >
      <span className="w-[131px]" />
      <div className="relative w-full">
        <ChartYAxisGrid bottomOffset={bottomOffset} />

        {isBenchmarkEnabled && (
          <ChartBenchmarkGrid
            benchmarkDetails={benchmarkDetails}
            bottomOffset={bottomOffset}
          />
        )}
      </div>

      <span className="w-[180px]" />
    </div>
  );
}

export default ChartYAxis;
